const AppRouterConstant = {
    APP_VERSION: "appVersion",
    PENDING_ROUTE: "pendingRoute"
}

export default AppRouterConstant